let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("76E7u")).then(() => parcelRequire('14xmF'));